export default {
  tabs: {
    fc: 'FA Checkup',
    fr: 'Financial Ratio',
    zmf: 'ZMF-Score',
  },

  tableParentCaption: {
    vr: 'Valuation Ratio',
    pr: 'Profitability Ratio',
    gr: 'Growth Ratio',
    lr: 'Liquidity Ratio',
    or: 'Operating Ratio',
    cr: 'Credit Risk Ratio',
    d: 'Dividend',
    car: 'Capital Adequacy Ratio',
    aqr: 'Asset Quality Ratio',
  },

  assetQualityChartTitle: {
    ta: 'Total Assets',
    tl: 'Total Loans',
    tnpl: 'Total Non-performing Loan',
    npl: 'NPL',
  },

  tableChildCaption: {
    //non-bank
    mc: 'Market Cap. (Bn. VND)',
    os: 'Outstanding Shares',
    eps: 'EPS (VND)',
    pe: 'P/E',
    pb: 'P/B',
    ps: 'P/S',
    pcf: 'P/Cash Flow',
    bvps: 'BVPS',
    ee: 'EV/EBITDA',

    rg: 'Revenue Growth',
    eg: 'EBIT Growth',
    npg: 'Net Profit Growth',
    roe: 'ROE',
    roa: 'ROA',
    roic: 'ROIC',
    gpm: 'Gross Profit Margin',
    npm: 'Net Profit Margin',

    cur: 'Current Ratio',
    car: 'Cash Ratio',
    fl: 'Financial Leverage',
    ic: 'Interest Coverage',

    dso: 'Days Sales Outstanding',
    dpo: 'Days Payable Outstanding',
    dio: 'Days Inventory Outstanding',
    at: 'Asset Turnover',

    dy: 'Dividend Yield',
    dpy: 'Dividend Payout Ratio',

    //bank
    dg: 'Deposit growth',
    lg: 'Loans growth',
    niig: 'Net Interest Income growth',
    nim: 'NIM %',
    cir: 'Cost-to-Income (CIR)',
    nn: 'Non-interest income/ Net Interest Income',
    yoea: 'Average Yield on Earning Assets (YOEA)',
    acof: 'Average Cost of Financing (COF)',

    eli: 'Equity/Liabilities',
    elo: 'Equity/Loans',
    ea: 'Equity/Assets',
    ldr: 'Loans/Deposit Ratio (LDR)',

    npl: 'NPL',
    llrn: 'Loan-loss reserves/NPLs',
    llrl: 'Loan-loss reserves/Loans',
    pol: 'Provision/Outstanding Loans',
  },

  profitabilityTitle: {
    bank: {
      roe: 'ROE %',
      roa: 'ROA %',
      nim: 'NIM %',
      cir: 'CIR %',
    },
    nonBank: {
      roe: 'ROE %',
      roa: 'ROA %',
      gpm: 'Gross Profit Margin',
      npm: 'Net Profit Margin',
    },
  },

  lstTab: {
    faCheckup: 'FA Checkup',
    financialRatio: 'Financial Ratio',
    zmfScore: 'ZMF-Score',
  },

  faCheckupHeader: {
    item: 'item',
    checkupItem: '%{checkupItem}',
    comparingCheckupItemOne: '%{comparingCheckupItemOne}',
    comparingCheckupItemTwo: '%{comparingCheckupItemTwo}',
  },

  faCheckupFooter: {
    excellent: 'Excellent',
    good: 'Good',
    neutral: 'Neutral',
    beAlert: 'Be Alert',
    watchOut: 'Watch Out',
    summary: `For more details on how to utilize FiinTrade Investment FA Checkup,
     <a target="_blank" rel="noreferrer noopener" href="%{url}">click here</a>
    `,
  },

  columnOneTable: {
    NON_BANKING: {
      RAPID_EQUITY_ISSUANCE: 'Rapid Equity Issuance',
      REVENUE_GROWTH: 'Revenue Growth',
      GROSS_PROFIT_MARGIN: 'Gross Profit Margin',
      PROFIT_GROWTH: 'Profit Growth',
      CFO_QUALITY: 'CFO Quality',
      OPERATION_EFFICIENCY: 'Financial Strength',
      DEBT_PRESSURE: 'Debt Pressure',
      CAPITAL_STRUCTURE: 'Capital Structure',
      ROE: 'ROE',
      FINANCIAL_PLANNING: 'Financial Planning',
    },
    BANKING: {
      DEPOSIT_GROWTH: 'Deposit Growth',
      CREDIT_GROWTH: 'Credit Growth',
      INTEREST_PROFIT_GROWTH: 'Interest Profit Growth',
      NIM_RATIO: 'NIM Ratio',
      LDR_Ratio: 'LDR Ratio',
      NPL_Ratio: 'NPL Ratio',
      CAR_Ratio: 'CAR Ratio',
      Business_Plan: 'Business Plan',
    },
  },

  titleChart: {
    dupont: 'DUPONT',
    profitability: 'PROFITABILITY',
    percentage: 'Percentage',
    time: 'Times',
    trillion: 'Trillion VND',
  },

  zTooltip: {
    firstRow: 'The likelihood of bankruptcy of a publicly',
    secondRow: 'traded manufacturing company',
  },

  mTooltip: {
    firstRow: 'The ability to be manipulated',
    secondRow: 'in the reported earnings of the company',
  },

  fTooltip: {
    firstRow: 'The fundamental strength of the enterprise',
  },

  footerNoteZBarChart: {
    safe: 'Safe Zone',
    nomal: 'Considered Gray Zone',
    distress: 'Considered Distress Zone',
  },

  footerNoteMBarChart: {
    notManipulator: 'Unlikely manipulator',
    manipulator: 'Likely Manipulator',
  },

  footerNoteFBarChart: {
    good: 'Considered strong',
    normal: 'Normal',
    weak: 'Considered weak',
  },

  listTitleTableFinancialRatio: {
    item: 'ITEM',
    industry: 'INDUSTRY',
    ttm: '%{year} (Q%{quarter} TTM)',
  },
  zmfFooter: `For more details on how to utilize Z-Score, M-Score and F-Score,
     <a target="_blank" rel="noreferrer noopener" href="%{url}">click here</a>
    `,
  financialRatio: {
    compareTo: 'COMPARE TO',
    timeTab: {
      quarterly: 'Quarterly',
      yearly: 'Yearly',
    },
    industry: 'Industry',
    ratioTitle: 'Ratio',

    revenue: 'Revenue (Bn. VND)',
    revenueGrowth: 'Revenue Growth (YoY) (%)',
    netProfit: 'Attribute to parent company (Bn. VND)',
    profitGrowth: 'Profit Growth (YoY) (%)',
    EBITMargin: 'EBIT Margin (%)',
    netProfitMargin: 'Net Profit Margin (%)',
    grossProfitMargin: 'Gross Profit Margin (%)',
    ROE: 'ROE (%)',
    ROIC: 'ROIC (%)',
    ROA: 'ROA (%)',

    currentRatio: 'Current Ratio',
    cashRatio: 'Cash Ratio ',
    quickRatio: 'Quick Ratio',
    interestCoverage: 'Interest Coverage',
    financialLeverage: 'Financial Leverage',

    assetTurnover: 'Asset Turnover',
    fixedAssetTurnover: 'Fixed Asset Turnover',
    daysSalesOutstanding: 'Days Sales Outstanding',
    daysInventoryOutstanding: 'Days  Inventory Outstanding',
    daysPayableOutstanding: 'Days Payable Outstanding ',
    cashCycle: 'Cash Cycle',

    debt: 'Debt/Equity',
    STAndLTBorrowing: '(ST+LT borrowings)/Equity',

    marketCapital: 'Market Capital (Bn. VND)',
    outstandingShare: 'Outstanding Share (Mil. Shares)',
    PE: 'P/E',
    PB: 'P/B',
    PS: 'P/S',
    PCashFlow: 'P/Cash Flow',
    EPS: 'EPS (VND)',
    BVPS: 'BVPS (VND)',
    EV: 'EV/EBITDA',

    effectiveRatio: 'Effective Ratio',
    liquidityRatio: 'Liquidity Ratio',
    efficiencyRatio: 'Efficiency Ratio',
    capitalStructureRatio: 'Capital Structure Ratio',
    valuationRatio: 'Valuation Ratio',
    coporationInfomation: 'Coporation Infomation',

    //Banking
    netInterestIncome: 'Net Interest Income (Bn. VND)',
    netInterestIncomeGrowth: 'Net Interest Income Growth (YoY) (%)',
    NIM: 'NIM (%)',
    depositGrowth: 'Deposit growth (%)',
    loansGrowth: 'Loans growth (%)',
    costToIncome: 'Cost to Income (CIR)',
    nonInterestIncomeInterestIncome: 'Non-interest income/Interest Income (%)',
    YOEA: 'Average Yield on Earning Assets (YOEA) (%)',
    COF: 'Average Cost of Financing (COF) (%)',

    equityPerLiabilities: 'Equity/Liabilities',
    equityPerLoans: 'Equity/Loans',
    equityPerAssets: 'Equity/Asset',
    LDR: 'LDR (%)',
    CAR: 'CAR (%)',

    CASARatio: 'CASA Ratio',
    NPL: 'NPL (%)',
    NPLs: 'Loan-loss reserves/NPLs (%)',
    LLRL: 'Loan-loss reserves/Loans (%)',
    POL: 'Provision/Outstanding Loans (%)',
    footerNote:
      'Notice: Quarterly growth is calculated by parallel period of previous year',
    footerNoteYearly: 'Note: Industry data is calculated annually.',
    industryNote:
      'The industry is taken by level 3 ICB industry classification',

    effectiveRatio: 'Effective Ratio',
    capitalRatio: 'Capital Ratio',
    assetQualityRatio: 'Asset quality Ratio',
    valuationRatio: 'Valuation Ratio',
    coporationInfomation: 'Coporation Infomation',
  },
};
